module.exports = __webpack_public_path__ + "img/gibraltar.c0e73633.svg";